import { FilterDefinitionDTO } from "../DTO/filterDefinitionDTO";
import { FileDefinition } from "./fileDefinition";
import { FilterProtocol } from "./filterProtocol";
import { FilterRuleDefinition } from "./filterRuleDefinition";

export class FilterDefinition{

    public id? : number;
    public name! : string;
    public description! : string;
    public fileDefinitionId!:number;
    public fileDefinition! : FileDefinition;
    public filterProtocols : FilterProtocol[] = [];
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : Date;
    public deleted : boolean = false;
    public ownedByEntityId?: number;
    public ownerEntityType?: string;
    public wizardSessionId?: number;

    constructor(){
    }

    public setFileDefinition(fd:FileDefinition){
        //use this method to correctly instantiate the protocols
        this.fileDefinition=fd;
        if(fd) this.filterProtocols.forEach(p=>p.createInputField(fd.fieldDefinitions));
    }

    public static mapFromDTO(param:FilterDefinitionDTO):FilterDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new FilterDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.fileDefinitionId = param.fileDefinitionId;
            obj.filterProtocols = param.filterProtocols.map(fp=>FilterProtocol.mapFromDTO(fp));
            obj.version = param.version;
            obj.published = param.published;
            if(param.added) obj.added = new Date(param.added);
            obj.deleted = param.deleted;
            obj.ownedByEntityId = param.ownedByEntityId;
            obj.ownerEntityType = param.ownerEntityType;
            obj.wizardSessionId = param.wizardSessionId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:FilterDefinition):FilterDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new FilterDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.fileDefinitionId = param.fileDefinition.id!;
            dto.filterProtocols = param.filterProtocols.map(fp=>FilterProtocol.mapToDTO(fp));
            dto.version = param.version;
            dto.published = param.published;
            if(param.added) dto.added = param.added.toISOString();
            dto.deleted = param.deleted;
            dto.ownedByEntityId = param.ownedByEntityId;
            dto.ownerEntityType = param.ownerEntityType;
            dto.wizardSessionId = param.wizardSessionId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    //use DTO to create a deep copy
    get clone():FilterDefinition{
        //memorize used filterRuleDefinitions first
        let usedFilterRuleDefinitions:FilterRuleDefinition[]=[];
        this.filterProtocols.forEach(fp=>{
            fp.filterRules.forEach(fr=>{
                if(usedFilterRuleDefinitions.findIndex(frd=>frd.id==fr.filterRuleDefinition.id)==-1){
                    usedFilterRuleDefinitions.push(fr.filterRuleDefinition);
                }
            });
        });
        let mappedFilterDefinition=FilterDefinition.mapToDTO(this);
        mappedFilterDefinition.id=0;
        mappedFilterDefinition.name="";
        mappedFilterDefinition.version=0;
        mappedFilterDefinition.description="";
        mappedFilterDefinition.published=false;
        mappedFilterDefinition.filterProtocols.forEach(p=>{
            p.id=0;
            p.filterRules.forEach(r=>{
                r.id=0;

            });
        });
        let mapFromDTOFilterDefinition = FilterDefinition.mapFromDTO(mappedFilterDefinition);
        mapFromDTOFilterDefinition.setFileDefinition(this.fileDefinition);
         //relate filterRuleDefinitions with clone
         mapFromDTOFilterDefinition.filterProtocols.forEach(fp=>{
            fp.filterRules.forEach(fr=>{
                fr.filterRuleDefinition=usedFilterRuleDefinitions.find(frd=>frd.id==fr.filterRuleDefinitionId)!;
            });
        });
        return mapFromDTOFilterDefinition;
    }

    public resetIds(){
        this.id=0;
        this.filterProtocols.forEach(p=>{
            p.id=0;
            p.filterRules.forEach(r=>r.id=0);
        });
    }

    get acceptFileTypes(){
        let types=".txt";
        if(this.fileDefinition?.type=='csv') types+=",.csv,.xml";
        return types
    }
}